import React, { Fragment, useContext, useState } from 'react'
import { AiOutlineQuestionCircle, AiFillFolder, AiFillFile, AiOutlineCloseCircle, AiOutlineSearch, AiOutlinePlusCircle } from 'react-icons/ai'

import { BiCalendar, BiEdit, BiSkipPrevious, BiSkipNext } from 'react-icons/bi'
import { FiClock } from 'react-icons/fi'
import Renderif from '../../components/renderif';
import SideMenu, { AdminSideMenu } from '../../components/sidemenu';
import DropDown, { DropDownOption } from '../../components/dropdown';
import { gray30, primary } from '../../utils/colors';
import { useNavigate } from 'react-router-dom';
import { Service } from '../../services/api';
import { AlertContext } from '../../context/alert_context';
import { GoStarFill } from "react-icons/go";
import { GoStar } from "react-icons/go";
import { AuthContext } from '../../context/auth_context';
import AgregarEspecialista from './agregar_especialista_admin';
import EditarEspecialista from './editar_especialista_admin';
import EditarUsuario from './editar_usuario_admin';
import DatesOfLaborEspecialist from './horario_laboral_especialista';
import { AiFillCloseCircle } from 'react-icons/ai'
import Loader from '../../components/loader'
import { FiShoppingBag, FiSettings } from 'react-icons/fi';




export default function EspecialistasAdmin() {

    const { notify } = useContext(AlertContext)
    const navigate = useNavigate();
    const { user } = useContext(AuthContext)

    const [state, setState] = useState({
        tab: 0,
        dropdown_users: 1,
        show_add_especialist: false,
        show_edit_especialist: false,
        show_edit_user: false,
        show_delete_especialist: false,
        show_leave_especialist: false,
        show_business_especialist_time: false,
        user_editing: [],
        specialist: [],
        especialistSelected: [],
        users: [],
        leave_date: null,
        especialist_leave_at: {
            startTime: 0,
            endTime: 0
        },
        loading: false,
    })





    const loadSpecialist = async () => {
        let _specialists = await Service('GET', 'Admin/list-specialist');
        setState({ ...state, show_add_especialist: false, specialist: _specialists.data })
    }

    const loadUsers = async (number) => {

        if (number == 1) {
            let _users = await Service('GET', `User/list?pageNumber=${state.dropdown_users + 1}&pageSize=25`);
            setState({ ...state, users: _users.data.data, tab: 1, dropdown_users: state.dropdown_users + 1 })
        } else if (number == -1 && state.dropdown_users > 1) {
            let _users = await Service('GET', `User/list?pageNumber=${state.dropdown_users - 1}&pageSize=25`);
            setState({ ...state, users: _users.data.data, tab: 1, dropdown_users: state.dropdown_users - 1 })
        } else if (number == 2) {
            let _users = await Service('GET', `User/list?pageNumber=${state.dropdown_users}&pageSize=25`);
            setState({ ...state, users: _users.data.data, tab: 1 })
        }
        else {
            let _users = await Service('GET', `User/list?pageNumber=1&pageSize=999`);
            _users.data.data = _users.data.data.filter(item => item.firstName.toUpperCase().includes(number.toUpperCase()))
            console.log(_users.data.data)
            setState({ ...state, users: _users.data.data, tab: 1 })
        }

    }

    useState(() => {
        const init = async () => {

            loadSpecialist()


        };
        init();
        return () => { }
    }, [])


    const y = [0, 30, 60, 90, 120, 150]
    const x = [
        {
            date: '1 Ago',
            value: 40
        },
        {
            date: '1 Ago',
            value: 120
        },
        {
            date: '1 Ago',
            value: 60
        },
        {
            date: '1 Ago',
            value: 83
        },
        {
            date: '1 Ago',
            value: 150
        }
    ]
    var weekday = new Array(7);
    weekday[0] = "Domingo";
    weekday[1] = "Lunes";
    weekday[2] = "Martes";
    weekday[3] = "Miercoles";
    weekday[4] = "Jueves";
    weekday[5] = "Viernes";
    weekday[6] = "Sabado";

    var months = new Array(7);
    months[0] = "Enero";
    months[1] = "Febrero";
    months[2] = "Marzo";
    months[3] = "Abril";
    months[4] = "Mayo";
    months[5] = "Junio";
    months[6] = "Julio";
    months[7] = "Agosto";
    months[8] = "Septiembre";
    months[9] = "Octubre";
    months[10] = "Noviembre";
    months[11] = "Diciembre";


    const onDelete = async () => {
        console.log(state.especialistSelected);
        let body = {
            "id": state.especialistSelected.id

        }
        // let deleteEspecialist = await Service('DELETE', 'User/'+ state.especialistSelected.id);
        // console.log(deleteEspecialist);
        loadSpecialist()
        setState({ ...state, show_delete_especialist: false })
    }

    const onSpecialistLeave = async () => {
        setState({ ...state, loading: true })
        for (let i = parseInt(state.especialist_leave_at.startTime); i < parseInt(state.especialist_leave_at.endTime); i++) {
            var start = new Date(state.leave_date.setHours(i, 0));

            var day = start.getDate();
            var month = start.getMonth() + 1; //months are zero based
            var year = start.getFullYear();
            const time = start.toLocaleTimeString('es-ES').replace(/(.*)\D\d+/, '$1');
            console.log(time)
            let date_parsed = year + '-' + month.pad() + '-' + day.pad() + 'T' + (time.length<5?"0"+time:time) + ':00.000Z';

            let body = {
                userId: "7ee52054-1e2f-4b43-b453-2c82a972d38c",
                specialistId: state.especialistSelected.id,
                date: date_parsed,
                description: "Fuera de Oficina",
            }

            const schedule = await Service('POST', 'Appointment', body);

            if (schedule?.status === 200) {
                notify({ title: 'Listo!', message: 'Se ha agendado un nueva cita.', type: 'success' })

            } else {
                notify({ title: 'Error!', message: 'No se puede agendar una cita en este momento.', type: 'error' })
            }
        }
        setState({ ...state, show_leave_especialist: false, loading: false })
    }

    const onDownloadReport = async () => {
        // let _DateStart=document.getElementById('reporDateStart').value;
        // let _DateEnd=document.getElementById('reporDateEnd').value;

        // if(_DateStart !="" &&_DateEnd !=""){
        //     console.log("descargar reporte con fechas")
        // }
        // else{
        //     console.log("descargar reporte total")
        // }
        const _usersReport = await Service('GET', 'Admin/download-users');
        console.log(_usersReport)

        if (_usersReport?.status === 200) {
            notify({ title: 'Listo!', message: 'Se ha descargado el reporte.', type: 'success' })

        } else {
            notify({ title: 'Error!', message: 'No se puede descargar el reporte por el momento.', type: 'error' })
        }
    }

    return (
        <>
            <Renderif isTrue={state.show_business_especialist_time}>
                <DatesOfLaborEspecialist userEditing={state.user_editing} onClose={(evt) => {
                    if (evt !== undefined) {
                        loadSpecialist()
                    }
                    setState({ ...state, show_business_especialist_time: false })

                }} />
            </Renderif>
            <Renderif isTrue={state.loading === true}>
                <Loader></Loader>
            </Renderif>
            <Renderif isTrue={state.show_add_especialist}>
                <AgregarEspecialista onClose={(evt) => {

                    if (evt !== undefined) {
                        loadSpecialist()
                    }
                    setState({ ...state, show_add_especialist: false })

                }} />
            </Renderif>

            <Renderif isTrue={state.show_edit_especialist}>
                <EditarEspecialista userEditing={state.user_editing} onClose={(evt) => {
                    if (evt !== undefined) {
                        loadSpecialist()
                    }
                    setState({ ...state, show_edit_especialist: false })

                }} />
            </Renderif>
            <Renderif isTrue={state.show_edit_user}>
                <EditarUsuario userEditing={state.user_editing} onClose={(evt) => {
                    if (evt !== undefined) {
                        loadSpecialist()
                    }
                    setState({ ...state, show_edit_user: false })

                }} />
            </Renderif>
            <Renderif isTrue={state.show_leave_especialist}>
                <div className='overlay d-flex justify-content-center align-items-center'>
                    <div className='bv-modal shadow'>
                        <div className='px-4 pt-3 pb-4 d-flex align-items-center'>
                            <div className='f-16 text-gray'>Bloquedo de horarios <strong>{state.especialistSelected.fullName}</strong></div>
                            <div className='col'></div>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {

                                setState({ ...state, show_leave_especialist: false })

                            }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                        </div>
                        <div className='px-4 pb-5'>
                            <div className='mt-3'>
                                <div className='f-14 bold text-gray'>Fecha para bloquear</div>
                                <div className='input--light'>
                                    <input onChange={(evt) => {
                                        let daySelected = new Date(new Date(evt.currentTarget.value).setHours('00', '00'));
                                        daySelected.setDate(daySelected.getDate() + 1);

                                        state.leave_date = daySelected;
                                        setState({ ...state })
                                    }} type="date" min="2024-01-01"></input>
                                </div>
                            </div>
                            <div className='mt-3'>
                                <div className='f-14 bold text-gray'>Hora inicio</div>
                                <select name="select" className='input--light' onChange={(evt) => {
                                    state.especialist_leave_at.startTime = evt.currentTarget.value

                                    setState({ ...state })

                                }}>
                                    <option>Hora inicio</option>
                                    <option value="8">08:00</option>
                                    <option value="9">09:00</option>
                                    <option value="10">10:00</option>
                                    <option value="11">11:00</option>
                                    <option value="12">12:00</option>
                                    <option value="13">13:00</option>
                                    <option value="14">14:00</option>
                                    <option value="15">15:00</option>
                                    <option value="16">16:00</option>
                                    <option value="17">17:00</option>
                                </select>
                            </div>
                            <div className='mt-3'>
                                <div className='f-14 bold text-gray'>Hora Fin</div>
                                <select name="select" className='input--light' onChange={(evt) => {
                                    state.especialist_leave_at.endTime = evt.currentTarget.value
                                    setState({ ...state })
                                }}>
                                    <option>Hora Fin</option>
                                    <option value="9">09:00</option>
                                    <option value="10">10:00</option>
                                    <option value="11">11:00</option>
                                    <option value="12">12:00</option>
                                    <option value="13">13:00</option>
                                    <option value="14">14:00</option>
                                    <option value="15">15:00</option>
                                    <option value="16">16:00</option>
                                    <option value="17">17:00</option>
                                    <option value="18">18:00</option>
                                    <option value="19">19:00</option>
                                </select>
                            </div>
                        </div>
                        <div className='d-flex b-top p-4'>
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                                setState({ ...state, show_leave_especialist: false })
                            }}>Cancelar</div>
                            <div className='bv-pill bv-pill--primary cursor-pointer' onClick={async () => {
                                onSpecialistLeave()


                            }}>Continuar</div>
                        </div>
                    </div>
                </div>
            </Renderif>
            <Renderif isTrue={state.show_delete_especialist}>
                <div className='overlay d-flex justify-content-center align-items-center'>
                    <div className='bv-modal shadow'>
                        <div className='px-4 pt-3 pb-4 d-flex align-items-center'>
                            <div className='f-16 text-gray'>Eliminar <strong>{state.especialistSelected.fullName}</strong></div>
                            <div className='col'></div>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {

                                setState({ ...state, show_delete_especialist: false })

                            }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                        </div>
                        <div className='px-4 pb-5'>
                            Estás seguro de eliminar a {state.especialistSelected.fullName}
                        </div>
                        <div className='d-flex b-top p-4'>
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                                setState({ ...state, show_delete_especialist: false })
                            }}>Cancelar</div>
                            <div className='bv-pill bv-pill--primary cursor-pointer' onClick={async () => {
                                onDelete()


                            }}>Continuar</div>
                        </div>
                    </div>
                </div>
            </Renderif>

            <div className='container-fluid h-100 d-flex'>


                {/* <SideMenu></SideMenu> */}
                <AdminSideMenu></AdminSideMenu>

                <div className='col hide-scroll'>

                    <div className='container-fluid bg-light'>
                        <div className='container'>
                            <div className='d-flex align-items-center bg-light p-3'>


                                <div className='d-flex align-items-center '>
                                    <div className='avatar avatar--mid'></div>
                                    <div className='col ps-3'>
                                        <div className='f-18 bold '>¡Hola! {user.firstName} {user.lastName}.</div>
                                        <div className='text-gray f-14 line-0'>Medicina General</div>
                                    </div>
                                </div>
                                <div className='col'></div>
                                <Renderif isTrue={state.tab === 1}>
                                    <div className='mx-3'>
                                        <div className='input--light'>
                                            <div className='bv-icon bv-icon--mid'><AiOutlineSearch size={30}></AiOutlineSearch></div>
                                            <input className='bg-transparent' placeholder='Buscar Usuario' onChange={(evt) => {
                                                if (evt.currentTarget.value != '') {
                                                    console.log("search")
                                                    loadUsers(evt.currentTarget.value);
                                                }

                                            }}></input>
                                        </div>
                                    </div>
                                </Renderif>
                                <div className='pe-2'>
                                    <DropDown title={''} icon={<FiSettings size={24} color={gray30}></FiSettings>}>
                                        <DropDownOption disabled>
                                            <div className='d-flex align-items-center px-2'>

                                                <div className='text-dark f-16 bold'>Etiquetas</div>

                                                <div className='col mx-5'></div>

                                                <div className='cursor-pointer text-decoration-underline text-primary bold f-14 prevent-select' onClick={() => { navigate('/administrador/tags') }}>Ver Etiquetas</div>

                                            </div>
                                        </DropDownOption>
                                    </DropDown>
                                </div>
                                <div className='bv-cta bv-cta--primary' onClick={() => {
                                    // setState({...state, show_agendar_cita:true})
                                    navigate('/administrador/calendario')
                                }}>
                                    Ver Agenda

                                </div>
                            </div>
                        </div>
                    </div>


                    <div className='container '>




                        <div className='row'>
                            <div className='col-12'>


                                <div className='d-flex align-items-center my-3'>
                                    <div className='bv-pill bv-pill--primary d-flex align-items-center ps-0 cursor-pointer me-1' onClick={() => {
                                        setState({ ...state, show_add_especialist: true })
                                    }}>
                                        <div className='ps-0'> <AiOutlinePlusCircle size={22} /></div>
                                        <div className='px-1'>Agregar Especialista</div>
                                    </div>

                                </div>
                                <div className='d-flex align-items-center my-3'>
                                    <div className={`bv-tab bv-tab--primary ${state.tab === 0 ? 'bv-tab--active' : ''}`} onClick={() => {
                                        setState({ ...state, tab: 0 })
                                    }}>Coaches <span className='text-blue f-12 bold ms-2'></span></div>

                                    <div className={`bv-tab bv-tab--primary ${state.tab === 1 ? 'bv-tab--active' : ''}`} onClick={() => {

                                        // setState({ ...state, tab: 1 });
                                        loadUsers(2);
                                    }}>Usuarios <span className='text-blue f-12 bold ms-2'></span></div>
                                </div>

                                <Renderif isTrue={state.tab === 0}>
                                    <div className='bv-table d-none d-sm-block'>
                                        <table className='w-100'>
                                            <thead>
                                                <tr>
                                                    <td>
                                                        <div className='d-flex align-items-center'>

                                                            {/* <div className='bv-icon'><BsFillPersonFill size={12} color="#777777" /></div> */}
                                                            <div className='text-gray line-0 f-14 bold'>Nombre</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            {/* <div className='bv-icon'><BsCalendar size={12} color="#777777" /></div> */}
                                                            <div className='text-gray f-14 bold line-0'>Correo</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            {/* <div className='bv-icon'><BsClock size={12} color="#777777" /></div> */}
                                                            <div className='text-gray f-14 bold line-0'>Fecha Ingreso</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            {/* <div className='bv-icon'><CgHashtag size={14} color="#777777" /></div> */}
                                                            <div className='text-gray f-14 bold line-0'>Teléfono</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            {/* <div className='bv-icon'><CgHashtag size={14} color="#777777" /></div> */}
                                                            <div className='text-gray f-14 bold line-0'>Pacientes</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            {/* <div className='bv-icon'><CgHashtag size={14} color="#777777" /></div> */}
                                                            <div className='text-gray f-14 bold line-0'>Valoración</div>
                                                        </div>
                                                    </td>
                                                    <td></td>
                                                    <td></td>


                                                </tr>
                                            </thead>
                                            <tbody>
                                                {state.specialist.map((item, i) => {
                                                    return (
                                                        <Fragment key={i}>
                                                            <tr className="">
                                                                <td>
                                                                    <div>
                                                                        <div className='d-flex align-items-center'>
                                                                            <div className='avatar'></div>
                                                                            <div className='col ps-3'>
                                                                                <div className='text-gray f-14 bold'>{item.fullName}</div>
                                                                                <div className='text-gray f-14 line-0'></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div>
                                                                        <div className='text-gray f-12'>{item.email}</div>

                                                                    </div>
                                                                </td>

                                                                {/* <td><div className='text-gray f-12'>{weekday[new Date(item.date).getDay()]} {new Date(item.date).getDate()} {months[new Date(item.date).getMonth()]} {new Date(item.date).getFullYear()}</div></td> */}
                                                                <td><div className='text-gray f-12'>{weekday[new Date(item.createdAt).getDay()]} {new Date(item.createdAt).getDate()} {months[new Date(item.createdAt).getMonth()]} {new Date(item.createdAt).getFullYear()}</div></td>
                                                                <td>
                                                                    <div>
                                                                        <div className='text-gray f-12'>{item.cellPhone}</div>

                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div>
                                                                        <div className='text-gray f-12'>{item.patients}</div>

                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div>
                                                                        <Rating value={5}></Rating>

                                                                    </div>
                                                                </td>
                                                                <td></td>



                                                                <td>
                                                                    <div className='d-flex'>
                                                                        <div className='col'></div>
                                                                        <div className='pe-4'>
                                                                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                                                                setState({ ...state, show_leave_especialist: true, especialistSelected: item })
                                                                            }}>
                                                                                <FiClock color={gray30} size={30}></FiClock>
                                                                            </div>
                                                                        </div>
                                                                        <div className='pe-4'>
                                                                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                                                                setState({ ...state, show_edit_especialist: true, user_editing: item })
                                                                            }}>
                                                                                <BiEdit color={primary} size={30}></BiEdit>
                                                                            </div>
                                                                        </div>
                                                                        {/* <div className='pe-4'>
                                                                        <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                                                            console.log(item);
                                                                            setState({ ...state, show_delete_especialist: true, especialistSelected: item })
                                                                        }}>
                                                                            <BiTrash color="red" size={30}></BiTrash>
                                                                        </div>
                                                                    </div> */}
                                                                        {/* <div className='pe-4'>
                                                                        <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                                                            setState({ ...state, show_business_especialist_time: true, especialistSelected: item });

                                                                        }}>
                                                                            <FaBusinessTime color={primary} size={30}></FaBusinessTime>
                                                                        </div>
                                                                    </div> */}
                                                                    </div>
                                                                </td>

                                                            </tr>



                                                        </Fragment>
                                                    )
                                                })}

                                            </tbody>

                                        </table>

                                        <div className='pt-5'></div>

                                        <div className='d-flex align-items-center p-2'>

                                            <div className='text-gray f-12 line-0'>Mostrar</div>


                                            <div className='mx-2'>
                                                <DropDown
                                                    title=''
                                                    open={false}
                                                    defaultValue={5}
                                                    _onChange={(evt) => {
                                                        console.log(evt)
                                                    }}>
                                                    <DropDownOption value={5} label="5">
                                                        <div className='f-14 text-gray'>5</div>
                                                    </DropDownOption>
                                                    <DropDownOption value={10} label="10">
                                                        <div className='f-14 text-gray'>10</div>
                                                    </DropDownOption>



                                                </DropDown>
                                            </div>



                                            {/* <div className='d-flex bv-dropdown mx-2'>
                                        <div className='text-black bold f-12 ms-1'>5</div>
                                        <div className='line-0'><IoMdArrowDropdown size={18} color="#000000" /></div>
                                </div> */}


                                            <div className='text-gray f-12 line-0'>Por Página</div>
                                            <div className='col'></div>


                                        </div>
                                    </div>
                                </Renderif>
                                <Renderif isTrue={state.tab === 1}>
                                    <div className='bv-table d-none d-sm-block'>
                                        <table className='w-100'>
                                            <thead>
                                                <tr>
                                                    <td>
                                                        <div className='d-flex align-items-center'>

                                                            {/* <div className='bv-icon'><BsFillPersonFill size={12} color="#777777" /></div> */}
                                                            <div className='text-gray line-0 f-14 bold'>Nombre</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            {/* <div className='bv-icon'><BsCalendar size={12} color="#777777" /></div> */}
                                                            <div className='text-gray f-14 bold line-0'>Correo</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            {/* <div className='bv-icon'><CgHashtag size={14} color="#777777" /></div> */}
                                                            <div className='text-gray f-14 bold line-0'>Teléfono</div>
                                                        </div>
                                                    </td>
                                                    <td></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {state.users.map((item, i) => {
                                                    return (
                                                        <Fragment key={i}>
                                                            <tr className="">
                                                                <td>
                                                                    <div>
                                                                        <div className='d-flex align-items-center'>
                                                                            <div className='avatar'></div>
                                                                            <div className='col ps-3'>
                                                                                <div className='text-gray f-14 bold'>{item.firstName} {item.lastName}</div>
                                                                                <div className='text-gray f-14 line-0'></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div>
                                                                        <div className='text-gray f-12'>{item.email}</div>

                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <div>
                                                                        <div className='text-gray f-12'>{item.cellPhone}</div>

                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className='d-flex'>
                                                                        <div className='col'></div>
                                                                        <div className='pe-4'>
                                                                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                                                                console.log(item)
                                                                                setState({ ...state, show_edit_user: true, user_editing: item })
                                                                            }}>
                                                                                <BiEdit color={primary} size={30}></BiEdit>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </td>
                                                            </tr>



                                                        </Fragment>
                                                    )
                                                })}

                                            </tbody>

                                        </table>

                                        <div className='pt-5'></div>

                                        <div className='d-flex align-items-center p-2'>
                                            <div>
                                                <div className='bv-pill bv-pill--primary d-flex align-items-center ps-0 cursor-pointer me-1' onClick={() => {
                                                    onDownloadReport()
                                                }}>
                                                    <div className='ps-0'> <AiOutlinePlusCircle size={22} /></div>
                                                    <div className='px-1'>Descargar reporte</div>
                                                </div>

                                            </div>
                                            {/* <input type='date' id='reporDateStart'></input>
                                            <input type='date' id='reporDateEnd'></input> */}
                                            <div className='col'></div>
                                            {/* <div className='text-gray f-12 line-0'>Página</div>


                                            <div className='mx-2'>
                                                <DropDown
                                                    title=''
                                                    open={false}
                                                    defaultValue={1}
                                                    _onChange={(evt) => {
                                                        setState({...state,dropdown_users:evt.value})
                                                        loadUsers(evt.value);
                                                    }}>
                                                    <DropDownOption value={1} label="1">
                                                        <div className='f-14 text-gray'>1</div>
                                                    </DropDownOption>
                                                    <DropDownOption value={2} label="2">
                                                        <div className='f-14 text-gray'>2</div>
                                                    </DropDownOption>
                                                    <DropDownOption value={3} label="3">
                                                        <div className='f-14 text-gray'>3</div>
                                                    </DropDownOption>
                                                    <DropDownOption value={4} label="4">
                                                        <div className='f-14 text-gray'>4</div>
                                                    </DropDownOption>
                                                    <DropDownOption value={5} label="5">
                                                        <div className='f-14 text-gray'>5</div>
                                                    </DropDownOption>
                                                    <DropDownOption value={6} label="6">
                                                        <div className='f-14 text-gray'>6</div>
                                                    </DropDownOption>
                                                    <DropDownOption value={7} label="7">
                                                        <div className='f-14 text-gray'>7</div>
                                                    </DropDownOption>
                                                    <DropDownOption value={8} label="8">
                                                        <div className='f-14 text-gray'>8</div>
                                                    </DropDownOption>
                                                    <DropDownOption value={9} label="9">
                                                        <div className='f-14 text-gray'>9</div>
                                                    </DropDownOption>
                                                    <DropDownOption value={10} label="10">
                                                        <div className='f-14 text-gray'>10</div>
                                                    </DropDownOption>
                                                </DropDown>
                                            </div> */}
                                            <BiSkipPrevious color={primary} size={30} onClick={() => {
                                                loadUsers(-1);
                                            }}></BiSkipPrevious>
                                            <div className='text-gray f-12 line-0'>Página {state.dropdown_users}</div>
                                            <BiSkipNext color={primary} size={30} onClick={() => {
                                                loadUsers(1);
                                            }}></BiSkipNext>
                                        </div>
                                    </div>
                                </Renderif>
                            </div>

                        </div>




                    </div>

                    <div className='my-5'></div>
                </div>
            </div>
        </>
    )
}



export function Rating({ value = 5 }) {

    return (
        <div className='d-flex'>
            <div className='bv-icon '>

                <Renderif isTrue={value > 0}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 1}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>

            </div>

            <div className='bv-icon'>
                <Renderif isTrue={value > 1}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 2}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>
            </div>

            <div className='bv-icon'>
                <Renderif isTrue={value > 2}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 3}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>
            </div>

            <div className='bv-icon'>
                <Renderif isTrue={value > 3}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 4}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>
            </div>

            <div className='bv-icon'>
                <Renderif isTrue={value > 4}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 5}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>
            </div>
        </div>
    )
}


